// src/FeedbackPage.js
//
// UPDATED to full CRUD. Kept the status filter buttons from the
// read-only version. Uses beneficiary_label for display.

import { useState, useEffect } from 'react';
import { API_BASE_URL } from './apiConfig';
import FeedbackForm from './FeedbackForm';

function FeedbackPage({ token }) {
  const [feedbackList, setFeedbackList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('all');
  const [showForm, setShowForm] = useState(false);
  const [editingFeedback, setEditingFeedback] = useState(null);

  const refreshFeedback = () => {
    fetch(`${API_BASE_URL}/api/feedback/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) setFeedbackList(data);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshFeedback();
  }, [token]);

  const filteredFeedback =
    activeFilter === 'all' ? feedbackList : feedbackList.filter((f) => f.status === activeFilter);

  const filters = [
    { value: 'all', label: 'All' },
    { value: 'new', label: 'New' },
    { value: 'reviewed', label: 'Reviewed' },
    { value: 'resolved', label: 'Resolved' },
  ];

  const handleNewClick = () => { setEditingFeedback(null); setShowForm(true); };
  const handleEditClick = (f) => { setEditingFeedback(f); setShowForm(true); };
  const handleSaved = () => { setShowForm(false); setEditingFeedback(null); refreshFeedback(); };
  const handleCancel = () => { setShowForm(false); setEditingFeedback(null); };

  const handleDelete = async (f) => {
    const confirmed = window.confirm('Delete this feedback entry? This cannot be undone.');
    if (!confirmed) return;
    await fetch(`${API_BASE_URL}/api/feedback/${f.id}/`, {
      method: 'DELETE',
      headers: { Authorization: `Token ${token}` },
    });
    refreshFeedback();
  };

  if (loading) return <p className="text-gray-500">Loading feedback...</p>;

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Feedback</h1>
        <button onClick={handleNewClick} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          + New Feedback
        </button>
      </div>

      {showForm && (
        <FeedbackForm token={token} feedback={editingFeedback} onSaved={handleSaved} onCancel={handleCancel} />
      )}

      <div className="flex gap-2 mb-4">
        {filters.map((f) => (
          <button
            key={f.value}
            onClick={() => setActiveFilter(f.value)}
            className={`px-3 py-1 rounded text-sm ${
              activeFilter === f.value ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            {f.label}
          </button>
        ))}
      </div>

      <table className="w-full bg-white rounded shadow">
        <thead>
          <tr className="text-left border-b">
            <th className="p-3">Beneficiary</th>
            <th className="p-3">Message</th>
            <th className="p-3">Status</th>
            <th className="p-3">Date Submitted</th>
            <th className="p-3">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredFeedback.map((f) => (
            <tr key={f.id} className="border-b hover:bg-gray-50">
              <td className="p-3">{f.beneficiary_label}</td>
              <td className="p-3">{f.message}</td>
              <td className="p-3 capitalize">{f.status}</td>
              <td className="p-3">{new Date(f.date_submitted).toLocaleDateString()}</td>
              <td className="p-3">
                <button onClick={() => handleEditClick(f)} className="text-blue-600 text-sm hover:underline mr-3">Edit</button>
                <button onClick={() => handleDelete(f)} className="text-red-600 text-sm hover:underline">Delete</button>
              </td>
            </tr>
          ))}
          {filteredFeedback.length === 0 && (
            <tr><td className="p-3 text-gray-400" colSpan="5">No feedback matches this filter.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default FeedbackPage;
